module.exports = __webpack_public_path__ + "img/ERUPCION_BUEN_ESTADO.png";